import React from 'react';
import { Button, notification } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { FileExcelTwoTone } from '@ant-design/icons';
import { getListDetailedCI } from '../../../services/clientInvoice';
import { downloadJSONFile } from 'utils/utils2';

export type ExportCIListButtonProps = ButtonProps & {
  jobid: number;
  setIsLoading: (isLoading: boolean) => void;
};

const ExportCIListButton: React.FC<ExportCIListButtonProps> = ({
  setIsLoading,
  size = 'small',
  jobid,

  ...props
}) => {
  return (
    <Button
      icon={<FileExcelTwoTone />}
      onClick={() => {
        setIsLoading(true);
        getListDetailedCI({
          cirefend: '',
          cirefstart: '',
          groupingLines: 'RENTAL',
          jobid: jobid,
          mgid: Number(localStorage.getItem('mgid')),
        })
          .then((res) => {
            downloadJSONFile(
              { data: res.data, list: res.list },
              `clientInvoice_printingFlow_${jobid}`
            );
            notification.success({ message: res.message });
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }}
    ></Button>
  );
};

export default ExportCIListButton;
